
import React, {useState, useEffect} from "react";
import axios from 'axios';
import validator from 'validator';
import {Link, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import GoogleRegisterAuthButton from "../component/GoogleRegisterAuthButton";


function RegisterContent() {
    let navigate = useNavigate();

    let [username,setUsername] = useState("");
    let [useremail,setUseremail] = useState("");
    let [userphone,setUserphone] = useState("");
    let [usergender,setUsergender] = useState("");
    let [userpassword,setUserpassword] = useState("");
    // let [userpassword2,setUserpassword2] = useState("");


    let [usernameerr,setUsernameerr] = useState(false);
    let [useremailerr,setUseremailerr] = useState(false);
    let [userphoneerr,setUserphoneerr] = useState(false);
    let [usergendererr,setUsergendererr] = useState(false);
    let [userpassworderr,setUserpassworderr] = useState(false);
    // let [userpassword2err,setUserpassword2err] = useState("");


    let [flagmsg,setFlagmsg]=useState(false);
    let [msg,setMsg]=useState("");
    let [msgcode,setMsgcode]=useState("");
    let [msgcolor,setMsgcolor]=useState("");
    let [btnreg,setBtnreg]=useState(false);




    async function userregister() {

        let flag = true;

        if (username.trim() === "") {
            setUsernameerr(true);
            flag = false;
        }

        // Mobile Number Validation
        if (!/^\d{10}$/.test(userphone.trim())) {
            setUserphoneerr(true);
            flag = false;
        } else {
            setUserphoneerr(false);
        }

        // Optional Email Validation
        if (useremail && !validator.isEmail(useremail)) {
            setUseremailerr(true);
            flag = false;
        }

        if (usergender.trim() === "") {
            setUsergendererr(true);
            flag = false;
        }

        if (userpassword.length < 6) {
            setUserpassworderr(true);
            flag = false;
        }

        console.log("userphone: ",userphone)

        if (!flag) return;

        const profileid = "SV" + Math.floor(Math.random() * 999999999);

        const fd = new FormData();
        fd.append("profile_id", profileid);
        fd.append("name", username);
        fd.append("email", useremail);
        fd.append("phone", userphone);
        fd.append("gender", usergender);
        fd.append("password", userpassword);

        try {

            setBtnreg(true);

            const resp = await axios.post(
                "https://suvivah.org/suvivah/api/registerprimarystep",
                fd
            );

            const data = resp.data;

            if (data.msgcode === 1) {

                // localStorage.setItem("pid", profileid);

                setUsername("");
                setUseremail("");
                setUserphone("");
                setUsergender("");
                setUserpassword("");

                Swal.fire({
                    icon: "success",
                    title: "Registration Successful",
                    text: data.msg,
                    confirmButtonColor: "#dc3545",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: true
                }).then(() => {

                    // Redirect if required
                    navigate("/login");

                });

            } else {

                Swal.fire({
                    icon: "warning",
                    title: "Registration Failed",
                    text: data.msg,
                    confirmButtonColor: "#dc3545",
                });

            }

        } catch (err) {

            Swal.fire({
                icon: "error",
                title: "Server Error",
                text:
                    err.response?.data?.msg ||
                    "Something went wrong. Please try again later.",
                confirmButtonColor: "#dc3545",
            });

            console.error(err);

        } finally {

            setBtnreg(false);

        }
    }

    useEffect(()=>{
        if (localStorage.getItem("pid")) {
            let path=`/dashboard`;
            navigate(path);
        }
    },[])



    return(
        <>

        
<div className="devider"></div>


<section className="register-row">
<div className="container">
    {/* <div className="row">
        <div className="col-md-12">
            <header>
                <h2 className="text-center mb-4">Create a new account</h2>
                <h5 class="text-center mb-4">
                    <span className="bg-primary py-1 px-3 text-light" >Step 1</span>
                    <span className="bg-white py-1 px-3 text-secondary bg-opacity-50" >Step 2</span>
                </h5>
            </header>
        </div>
    </div> */}

    {flagmsg?<div className={msgcolor}>{msg}</div>:''}

    <div className="container py-3">
        <div className="row justify-content-center">
            <div className="col-lg-7 col-md-7">

                <div className="card border-0 shadow-lg rounded-4 overflow-hidden">

                    {/* Header */}
                    <div className="register-header text-white text-center py-3">
                        <i className="bi bi-person-plus-fill display-3 mb-3"></i>
                        <h3 className="fw-bold mb-1 text-light">Create New Account</h3>
                        <p className="mb-0 small">Join us and begin your journey toward an ideal marriage!</p>
                    </div>

                    <div className="card-body p-4">

                        {/* Full Name */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Full Name <sups><i className="fa fa-star text-danger text-xs"></i></sups>
                            </label>
                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="bi bi-person"></i>
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Full Name"
                                    onChange={(ev) => {
                                        setUsername(ev.target.value);
                                        if (ev.target.value.length > 1) {
                                            setUsernameerr(false);
                                        }
                                    }}
                                />
                            </div>

                            {usernameerr && (
                                <small className="text-danger">
                                    Full Name Required
                                </small>
                            )}
                        </div>

                        {/* Email */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Email  <sups><i className="fa fa-star text-danger text-xs"></i></sups>
                            </label>

                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="bi bi-envelope"></i>
                                </span>

                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter Email"
                                    onChange={(ev) => {
                                        setUseremail(ev.target.value);
                                        setUseremailerr(false);
                                    }}
                                />
                            </div>

                            {useremailerr && (
                                <small className="text-danger">
                                    Valid Email Required
                                </small>
                            )}
                        </div>

                        {/* Phone */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Mobile Number  <sups><i className="fa fa-star text-danger text-xs"></i></sups>
                            </label>

                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="bi bi-telephone"></i>
                                </span>

                                <input
                                    type="text"
                                    maxLength={10}
                                    className="form-control"
                                    placeholder="Enter Mobile Number (Optional)"
                                    onChange={(ev) => {
                                        setUserphone(ev.target.value);

                                        if (ev.target.value.length > 1) {
                                            setUserphoneerr(false);
                                        }
                                    }}
                                />
                            </div>

                            {userphoneerr && (
                                <small className="text-danger">
                                    Mobile Number Required
                                </small>
                            )}
                        </div>

                        {/* Gender */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Gender  <sups><i className="fa fa-star text-danger text-xs"></i></sups>
                            </label>

                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="bi bi-gender-ambiguous"></i>
                                </span>

                                <select
                                    className="form-select"
                                    onChange={(ev) => {
                                        setUsergender(ev.target.value);

                                        if (ev.target.value) {
                                            setUsergendererr(false);
                                        }
                                    }}
                                >
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div>

                            {usergendererr && (
                                <small className="text-danger">
                                    Gender Required
                                </small>
                            )}
                        </div>

                        

                        {/* Password */}
                        <div className="mb-4">
                            <label className="form-label fw-semibold">
                                Password  <sups><i className="fa fa-star text-danger text-xs"></i></sups>
                            </label>

                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="bi bi-lock"></i>
                                </span>

                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Enter Password"
                                    onChange={(ev) => {
                                        setUserpassword(ev.target.value);

                                        if (ev.target.value.length >= 6) {
                                            setUserpassworderr(false);
                                        }
                                    }}
                                />
                            </div>

                            {userpassworderr && (
                                <small className="text-danger">
                                    Minimum 6 characters required
                                </small>
                            )}
                        </div>

                        {/* Register Button */}
                        <div className="d-flex justify-content-center">
                            <button
                                type="button"
                                className="btn btn-danger btn-lg w-custom-75 rounded-pill fw-bold"
                                onClick={userregister}
                                disabled={btnreg}
                            >
                                {btnreg ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Registering...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-person-plus-fill me-2"></i>
                                        Create Account
                                    </>
                                )}
                            </button>
                        </div>



                        {/* Google Authentication */}
                        <div className="text-center my-4">

                            <div className="text-muted mb-3 fw-bold">

                                OR

                            </div>

                            <GoogleRegisterAuthButton/>

                        </div>
                        {/* Google Authentication */}




                        <div className="text-center mt-4">
                            <small className="text-muted">
                                Already have an account?
                                <Link to="/login" className="text-danger fw-bold ms-1 text-decoration-none">
                                    Login
                                </Link>
                            </small>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>

    {/* <div className="row">
        <div className="col-md-8 offset-md-2">
                <div className="register_box">
            <div className="row mb-3">
                <div className="col-md-12">
                     <input type="text" className="form-control"  placeholder="Enter Full Name" 
                     onChange={(ev)=>{
                        setUsername(ev.target.value)
                        if (ev.target.value.length>1) {
                            setUsernameerr(false);
                        }
                    }} />
                    {usernameerr?<div className='text text-danger small'>Full Name Required</div>:''}


                </div>
                <div className="col-md-12">
                    <input type="email" className="form-control" id="email" placeholder="Enter Email (Optional)" onChange={(ev)=>{
                        setUseremail(ev.target.value)
                        if (ev.target.value.length>1) {
                            setUseremailerr(false);
                        }
                    }} />
                    {useremailerr?<div className='text text-danger small'>User Email Required</div>:''}
                </div>
                
            </div>

            <div className="row mb-3">          
                <div className="col-md-12">
                     <select className="form-select" onChange={(ev)=>{
                            setUsergender(ev.target.value);
                            if (ev.target.value.length>0) {
                                setUsergendererr(false);
                            }
                        }}>
                          <option value={""}>Select Gender</option>
                          <option value={"Male"}>Male</option>
                          <option value={"Female"}>Female</option>
                        </select> 
                        {usergendererr?<div className='text text-danger small'>User Gender Required</div>:''}
                </div>
                <div className="col-md-12">
                    <input type="text" className="form-control" maxLength={10} id="email" placeholder="Enter Phone" onChange={(ev)=>{
                        setUserphone(ev.target.value)
                        if (ev.target.value.length>1) {
                            setUserphoneerr(false);
                        }
                    }} />
                     {userphoneerr?<div className='text text-danger small'>User Phone Required</div>:''}

                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-12">
                     <input type="password" className="form-control"  placeholder="Enter Password" onChange={(ev)=>{
                                setUserpassword(ev.target.value);
                                if (ev.target.value.length>=6 && ev.target.value==userpassword2) {
                                    setUserpassworderr(false);
                                }
                            }} /> 
                    {userpassworderr?<div className='text text-danger small'>Minimum 6-characters password Required</div>:''}
                </div>
                {/* <div className="col-md-6">
                    <input type="password" className="form-control" id="email" placeholder="Enter Confirm Password" onChange={(ev)=>{
                                setUserpassword2(ev.target.value);
                                if (ev.target.value.length>=6 && ev.target.value==userpassword) {
                                    setUserpassworderr(false);
                                }
                            }} /> 
                    {userpassworderr?<div className='text text-danger small'>Both Password doesn't match</div>:''}
                </div>
            </div>

            <div className="row">                
                <div className="col-md-12 text-center">
                   <button type="button" className="btn btn-red px-5 t" onClick={userregister} disabled={btnreg} >Register</button>
                </div>               
            </div>

            </div>
        </div>

    </div> */}
</div>
</section>



        </>
    );
}

export default RegisterContent;